import React from "react";
import FormSender from "./FormSender";
import "../styles/_contactUs.scss";
interface Props {}

const ContactUs: React.FC<Props> = (props) => {
  return (
    <div className="ContactUs container padding100" id="contactUs">
      <h6>AL-MARE</h6>
      <h1>CONTACT US</h1>
      <div className="row flex-column flex-lg-row">
        <div className="col-12 col-lg-8">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3055.1718063123917!2d23.50136023517187!3d40.026943413562805!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14a628d9d8795e85%3A0xb782b7913062ec3f!2sAl%20Mare!5e0!3m2!1sen!2smk!4v1673806741717!5m2!1sen!2smk"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
          <ul className="py-4">
            <li className="mb-2">
              <i className="fas fa-map-marker-alt"></i>{" "}
              <small> Polichrono Chalkidiki, Greece</small>{" "}
            </li>
            <li className="mb-2">
              <i className="fas fa-mobile-alt "></i>
              <small> 00 30 23740 53322</small>{" "}
            </li>
          
            <li className="mb-2">
              <i className="far fa-envelope"></i>
              <small>info.almare@gmail.com</small>{" "}
            </li>
            <li className="mb-2">
              <i className="fas fa-globe"></i>
              <small>www.almare-hotel.com</small>{" "}
            </li>
          </ul>
        </div>
        <div className="col-12 col-lg-4">
          <FormSender />
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
